import script from "./AccountView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountView.vue?vue&type=script&setup=true&lang=ts"

import "./AccountView.vue?vue&type=style&index=0&id=d7842e96&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7842e96"]])

export default __exports__